import React, { useMemo } from 'react';
import { useTable } from 'react-table';
import { useContext } from 'react'
import { BackendContext } from '../utils/BackendContext';
import { COLUMNS } from './columns';
import './EncountersTable.css';
import {ScrollView} from 'react-native';
import { useNavigate } from "react-router-dom";

export const EncountersTable = () => {
    const MOCK_DATA = useContext(BackendContext).get_campaigns();

 /* Using useMemo hook ensures that the data
    is not reacreated on every render
    if you did not memose columns and data, 
    react table would think that it is receiving
    new data on every render and attempt to recalculate
    a lot of logic every single time, affecting the 
    component's performance */

    const columns = useMemo(() => COLUMNS, [])
    const data = useMemo(() => MOCK_DATA, [MOCK_DATA])

 /* Functions and arrays that the use table hook
    from react-table package has provided to enable
    straightforward table creation */

    const { 
        getTableProps, 
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({
        columns,
        data
    })

    const navigate = useNavigate();

    /* TO DO: Function to be modified so that the selected
     campaign from encounters table will indicate the 
     corresponding data of a patient from that campaign. */
    const handleRowClick = () => {
        navigate("/")
    }

  return (
    <ScrollView>
     <table className="table" style={{overflowY:"scroll"}} {...getTableProps()}>
        <thead>
        <h1 className = "header" style={{ fontSize: "20px"}}>Encounters</h1>
            {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                    {
                        headerGroup.headers.map((column) => (
                            <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                        ))}
                </tr>
            ))}  
        </thead>
        <tbody {...getTableBodyProps()}>
            {
                rows.map(row => {
                    prepareRow(row)
                    return (   
                            <tr onClick={()=> handleRowClick()} {...row.getRowProps()}>    
                                {row.cells.map((cell) => {       
                                    return <td {...cell.getCellProps()}> {cell.render('Cell')} </td>          
                                })}       
                            </tr>                    
                    )
                })
            }

        </tbody>
     </table>
    </ScrollView>
  )
}

export default EncountersTable;